import { render } from "./SelectTariff.vue?vue&type=template&id=83e20bf8"
import script from "./SelectTariff.vue?vue&type=script&lang=js"
export * from "./SelectTariff.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__